import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { TShirtIcon } from '@phosphor-icons/react'

import { BackListButton } from '@reveni-io/reveni-ui'

import FiltersSection from '@/common/components/FiltersSection/FiltersSection'
import AppContext from '@/common/context/app.context'
import useRegions from '@/common/hooks/useRegions/useRegions'
import useReturnPortalFeatures from '@/common/hooks/useReturnPortalFeatures/useReturnPortalFeatures'
import MostReturnedCard from '@/metrics/components/MostReturnedCard/MostReturnedCard'
import Product from '@/metrics/components/Product/Product'
import ProductMetrics from '@/metrics/components/ProductMetrics/ProductMetrics'
import { groupByValues } from '@/metrics/constants'
import { getTitleByOrdering } from '@/metrics/helpers/helpers'
import useFilters from '@/metrics/hooks/useFilters/useFilters'
import routes from '@/Router/routes.constants'

import useProductMetrics from './hooks/useProductMetrics'
import * as Styles from './styles'

const ProductMetricsDetailPage = ({ isUnifiedDashboard }) => {
  const { t } = useTranslation()
  const { position } = useParams()
  const { info } = useContext(AppContext)
  const { regions } = useRegions()
  const {
    commonFilters,
    setCommonFilters,
    getUrlSearchParams,
    productsFilters,
    returnSalesRatioFilters,
    setReturnSalesRatioFilters,
    returnsAndExchangesRatioFilters,
    setReturnsAndExchangesRatioFilters,
  } = useFilters()
  const { product, handleFiltersChange, loadingTopReturnedProducts } = useProductMetrics({
    returnPortalId: isUnifiedDashboard ? null : info?.selectedReturnPortal?.id,
    setCommonFilters,
    commonFilters,
    position,
    groupBy: groupByValues.products,
    productsFilters,
  })
  const { returnPortalFeatures } = useReturnPortalFeatures({ returnPortalId: info?.selectedReturnPortal?.id })
  const salesOrdersDataActivated = returnPortalFeatures?.sales_orders_data_activated

  const getBackUrl = () => {
    return `${isUnifiedDashboard ? routes.merchantDashboardPage : routes.dashboardPage}?${getUrlSearchParams()}`
  }

  return (
    <Styles.Container>
      <Styles.HeaderContainer>
        <BackListButton to={getBackUrl()}>{t('Volver al dashboard')}</BackListButton>
        <FiltersSection regions={regions} filters={commonFilters} onChange={handleFiltersChange} />
      </Styles.HeaderContainer>
      <MostReturnedCard
        Icon={TShirtIcon}
        title={getTitleByOrdering('Productos', productsFilters?.ordering, t)}
        loading={loadingTopReturnedProducts}
        item={
          product?.id && (
            <Product
              product={{ ...product, index: Number(position) + 1 }}
              showAmounts={false}
              isUnifiedDashboard={isUnifiedDashboard}
            />
          )
        }
        percentage={product?.percentage}
        count={product?.count}
        sales={product?.sales}
        salesOrdersDataActivated={salesOrdersDataActivated || isUnifiedDashboard}
      />
      {product && (
        <ProductMetrics
          loading={loadingTopReturnedProducts}
          product={product}
          productPosition={position}
          returnPortalId={isUnifiedDashboard ? null : info?.selectedReturnPortal?.id}
          commonFilters={commonFilters}
          returnSalesRatioFilters={returnSalesRatioFilters}
          setReturnSalesRatioFilters={setReturnSalesRatioFilters}
          returnsAndExchangesRatioFilters={returnsAndExchangesRatioFilters}
          setReturnsAndExchangesRatioFilters={setReturnsAndExchangesRatioFilters}
          salesOrdersDataActivated={salesOrdersDataActivated}
          variantsOrdering={productsFilters?.ordering}
          isUnifiedDashboard={isUnifiedDashboard}
        />
      )}
    </Styles.Container>
  )
}

export default ProductMetricsDetailPage
